export default defineNuxtRouteMiddleware(() => {
	const {isAuthenticated} = useAuth();
	if (!isAuthenticated.value) {
		return navigateTo({name: 'nakupni-seznamy'}, {redirectCode: 302});
	}
});
